import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Checkbox,
  Chip,
  Container,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";

import { InputYear } from "../../Components/Inputs/Input_Year.jsx";
import { errorClear, errorSet, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";

import { set } from "lodash";

import ValueInflatable from "../../App/ValueInflatable.jsx";
import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  CleanAvail,
} from "../../App/Account_urls.jsx";

import {
  CollapseStateLabel,
  CollapseAdd,
  CollapseDelete,
  CollapseAddLabel,
} from "../../App/CollapseButtons.jsx";
import { AddDialog } from "../../Components/AddDialog.jsx";
import { InputMoney } from "../../Components/Inputs/Input_Money.jsx";
import { InputPercentage } from "../../Components/Inputs/Input_Percentage.jsx";
import { Input_label, InputName } from "../../Components/Inputs/Input_Name.jsx";
import { InputSelect1, InputSelectN } from "../../Components/Inputs/Select.jsx";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";
import { Arrayify } from "../../Functions/utils.jsx";

var pfrom = {
  Id: 0,
  Account: "",
  SpousePercentage: 0,
  UseHBP: true,
  AllTFFHSA: true,
  SpouseTFFHSA: true,
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
};

var init_v = {
  Id: 0,
  Actual: false,
  Addtional: false,
  SpousePercentage: 0,
  UpToAge: 0,
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
};

var ret_v = {
  Rate: 0,
  Type: "Income",
  SpousePercentage: 0,
  Id: 0,
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },

};
var exp_v = {
  Value: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
}

var income = {
  SpousePercentage: 0,
  Income: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
  Expense: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
  Percent: 100,
}

var ann = {
  Id: 0,
  Year: new Date().getFullYear() - 1,
  Comment: "",
  BirthYear: 1970,
  Return: [
    {
      Rate: 0,
      Type: "Income",
      Id: 0,
      SpousePercentage: 0,
      Value: {
        Value: 0,
        Year: new Date().getFullYear() - 1,
        Threshold: 0,
        Type: "Yearly",
        Rate: 0,
      },
    },
  ],
  Expenses: {
    Value: 0,
    Year: new Date().getFullYear() - 1,
    Threshold: 0,
    Type: "Yearly",
    Rate: 0,
  },
  Income: {
    SpousePercentage: 0,
    Income: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    Expense: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    Percent: 0,
  },


  Sell: {
    Percentage: 0,
    Value: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    Costs: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
  },

  Init: [init_v],
  Purchase: {
    SpousePercentage: 0,
    Value: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    Costs: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    From: [pfrom],
  },
  CostBasis: 0,
};

var ds = {
  Name: "",
  BirthYear: 1970,
  Priority: 0,
  Annual: [ann],
};

const PurchaseFrom = ({ avail, form, HBPMax, onChange, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChange_account = (e) => {
    let v = e.target.value
    let ind = avail.PurchaseAccounts.indexOf(v)
    console.log(v)
    console.log(ind)
    if (ind !== -1) {
      let ty = avail.PurchaseAccountTypes[ind]
      let nf = {
        ...form,
        ["Account"]: v,
        ["AccountType"]: ty,
      };
      console.log(nf);
      onChange(nf);
    }
  };
  const onChangeValue = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      SpousePercentage: SpousePercentage,
      [name]: value,
    };
    onChange(nf);
  };

  const getMax = () => {
    if (form.AccountType === "RRSP" && form.UseHBP) {
      return HBPMax
    }
    return null
  }

  return (
    <>
      <Stack direction="row" spacing={5}>
        <InputSelect1
          label="$ Source Account"
          value={form.Account}
          onChange={onChange_account}
          name="Account"
          avail={avail.PurchaseAccounts}
        />
        {form.AccountType === "RRSP" && (
          <InputCheck
            label="UseHBP"
            name="UseHBP"
            value={form.UseHBP}
            onChange={(n, v) => {
              let nf = { ...form, [n]: v, };
              onChange(nf);
            }}
          />
        )}
        {form.AccountType === "TFFHSA" && (
          <Stack  >
            <InputCheck
              label="All TFFHSA"
              name="AllTFFHSA"
              value={form.AllTFFHSA}
              sx={{ mt: -3 }}
              onChange={(n, v) => {
                let nf = { ...form, [n]: v, };
                onChange(nf);
              }}
            />
            <InputCheck
              label="Spouse's TFFHSA"
              name="SpouseTFFHSA"
              value={form.SpouseTFFHSA}
              sx={{ mt: -4 }}
              onChange={(n, v) => {
                let nf = { ...form, [n]: v, };
                onChange(nf);

              }}
            />
          </Stack>
        )}

        {form.AccountType !== "TFFHSA" && (
          <>
            <ValueInflatable
              key="form.value"
              label="Source"
              form={form.Value}
              onChange={onChangeValue}
              max={getMax()}
              dosp={true}
              SpousePercentage={form.SpousePercentage}
              showInf={false}
              avail={avail}
              name="Value"
              dosp={false} // this is unused right now anyway so just remove it, till its dealt with
              onError={onError}
            />

          </>
        )}
      </Stack>
    </>
  );
};

const Purchase = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeValue = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      SpousePercentage: SpousePercentage,
      [name]: value,
    };
    onChange(nf);
  };
  const myChangePurchaseCosts = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      [name]: value,
    };
    onChange(nf);
  };
  const onAdd = (name) => {
    let n = structuredClone(pfrom);
    let json = [];
    if (form[name]) {
      json = form[name].slice();
      n.Id = Math.max(...form[name].map((o) => o.Id), 0) + 1;
    }
    console.log(n);
    json.push(n);
    console.log(json);
    onChange_any(name, json);
  };

  const onChangeSub_i = (name, i, value) => {
    let json = form[name];
    json[i] = value;
    onChange_any(name, json);
  };

  const onDelete_i = (name, Id) => {
    let json = form[name].slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any(name, json);
  };
  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2}>
        <ValueInflatable
          key="form.value"
          label="Purchase"
          form={form.Value}
          onChange={onChangeValue}
          dosp={true}
          showInf={false}
          // doRepeat={true}
          // doUpTo={true}
          SpousePercentage={form.SpousePercentage}
          avail={avail}
          name="Value"
          onError={(e) => myError("valueI", null, e)}
        />
        <ValueInflatable
          xlabel="Purchase Costs"
          form={form.Costs}
          name="Costs"
          dosp={false}
          doInfR={true}
          showInf={false}
          onChange={myChangePurchaseCosts}
          avail={avail}
          onError={onError}
        />

        <CollapseAddLabel label="$ Source" mt={2} onClick={() => onAdd("From")} />
        {console.log("HERE")}
        <Stack spacing={2}>
          {console.log(form)}
          {Arrayify(form.From).map((v, i) => (
            <Stack key={"st-" + i} direction="row" spacing={2}>
              <PurchaseFrom
                form={v}
                HBPMax={form.HBPMax}
                avail={avail}
                onChange={(e) => onChangeSub_i("From", i, e)}
                onError={(e) => myError("purfrom", i, e)}
              />
              <CollapseDelete
                onClick={(e) => onDelete_i("From", v.Id)}
              />
            </Stack>
          ))}
        </Stack>

      </Stack>
    </Stack>
  );
};

const Income = ({ avail, form, onChange, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeValueI = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      SpousePercentage: SpousePercentage,
      [name]: value,
    };
    console.log(nf);
    onChange(nf);
  };

  const onChangeValueE = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      [name]: value,
    };
    console.log(nf);
    onChange(nf);
  };


  return (
    <>
      <Stack direction="row" spacing={2}>
        <InputPercentage
          label="Rental % of Property"
          percent={form.Percent}
          name="Percent"
          onChange={onChange_t}
        />
        <ValueInflatable
          key="form.value.income"
          label="Income"
          form={form.Income}
          onChange={onChangeValueI}
          dosp={true}
          SpousePercentage={form.SpousePercentage}
          avail={avail}
          name="Income"
          onError={onError}
          showInf={false}

        />
        <ValueInflatable
          key="form.value.expense"
          label="Expense"
          form={form.Expense}
          onChange={onChangeValueE}
          dosp={false}
          avail={avail}
          name="Expense"
          onError={onError}
          showInf={false}
        />
      </Stack>
    </>
  );
};

const ValueInit = ({ avail, form, onChange, dosp, dospAlways, doInfAlways, onError }) => {
  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeMe = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form,
      UpToAge: uptoage,
      SpousePercentage: SpousePercentage,
      Value: value,
    };
    onChange(nf);
  };
  return (
    <Stack direction="row" spacing={2}>
      <Stack>
        <FormControlLabel
          sx={{ mt: -4 }}
          control={
            <Checkbox
              size="small"
              checked={form.Actual}
              onChange={(e) => {
                onChange_any("Actual", e.target.checked);
              }}
            />
          }
          label="Actual"
        />
        <FormControlLabel
          sx={{ mt: -2 }}
          control={
            <Checkbox
              size="small"
              checked={form.Additional}
              onChange={(e) => {
                onChange_any("Additional", e.target.checked);
              }}
            />
          }
          label="Additional"
        />
      </Stack>
      <ValueInflatable
        label="Property"
        form={form.Value}
        dosp={dosp}
        dospAlways={dospAlways}
        doInfAlways={doInfAlways}
        doInfR={true}
        infMinPct={-20}
        // doThr={false}
        SpousePercentage={form.SpousePercentage}
        onChange={onChangeMe}
        avail={avail}
        onError={onError}
      />
    </Stack>
  );
};

const ValueYear = ({ avail, form, onChange, dosp, liabilityAccounts, allowIncome, onError }) => {
  const [errors, setErrors] = useState({})

  const [addIncome, setAddIncome] = useState(false);
  const [addPurchase, setAddPurchase] = useState(false);
  const [addSell, setAddSell] = useState(false);
  const [addNotes, setAddNotes] = useState(false);

  const onChange_any = (n, v) => {
    console.log("VY:change");
    console.log(form);
    console.log(n);
    console.log(v);
    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
  };


  const onChange_two = (n1, v1, n2, v2) => {
    let nf = {
      ...form,
      [n1]: v1,
      [n2]: v2,
    };
    console.log(nf);
    onChange(nf);
  };
  const myChangeExpenses = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      [name]: value,
    };
    //console.log(nf);
    onChange(nf);
  };

  const myChangeSellCosts = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form.Sell,
      Costs: value,
    };
    onChange_any("Sell", nf);
  };



  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onChangeInit = (e, i) => {
    console.log("VY:onchangeMe");
    console.log(e);
    console.log(i);
    let json = form;
    json.Init[i] = e;
    onChange_any("Init", json.Init);
  };
  const onChangeSub = (n, v) => {
    console.log("oCS");
    console.log(n);
    console.log(v);
    onChange_any(n, v);
  };

  const onChangeSub_i = (name, i, value) => {
    let json = form[name];
    json[i] = value;
    onChange_any(name, json);
  };

  const onChangeSub_incexp = (name, i, inc, exp) => {
    let json = form[name];
    json[i] = inc;
    onChange_two(name, json, "Expense", exp);
  };

  const onChangeSellV = (value, uptoage, SpousePercentage) => {
    let nf = {
      ...form.Sell,
      Value: value,
    };
    onChange_any("Sell", nf);
  };
  const onChangeSellP = (e) => {
    let nf = {
      ...form.Sell,
      Percentage: e.target.value,
    };
    onChange_any("Sell", nf);
  };

  const onAdd = () => {
    let n_init = structuredClone(init_v);
    let json = [];
    if (form.Init) {
      json = form.Init.slice();
      n_init.Id = Math.max(...form.Init.map((o) => o.Id), 0) + 1;
    }
    console.log(n_init);
    json.push(n_init);
    onChange_any("Init", json);
  };

  const onAdd_R = () => {
    let n = structuredClone(income);


    onChange_any("Income", n)

  };

  const onAddIncome = (v) => {
    if (v) {
      if (!form.Income) {
        onAdd_R();
      }
    }
    setAddIncome(v);
  };

  const onDelete = (e, Id) => {
    let json = form.Init.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Init", json);
  };

  useEffect(() => {
    console.log(form);
    console.log("check : " + form.Sell.Percentage);
    if (form.Sell.Percentage > 0 || form.Sell.Value.Value !== 0) {
      setAddSell(true);
    }
    console.log("check : " + form.Purchase.Value.Value);
    if (form.Purchase.Value.Value > 0) {
      setAddPurchase(true);
    }
    if (form.Income.Percentage > 0 || form.Income.Income.Value > 0) {
      console.log("check : " + form.Income);
      setAddIncome(true);
    }
    if (form.Comment && form.Comment !== "") {
      setAddNotes(true)
    }
  }, [form]);

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }


  return (
    <Container maxWidth="true">
      <Box sx={{ my: 1, pt: 3, pb: 1, pl: 2, border: "1px solid grey" }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <InputYear
              year={form.Year}
              birthYear={form.BirthYear}
              onChange={onChange_t}
            />
            {/* <CollapseAddLabel 
            label="Value" 
            onClick={onAdd} 
            /> */}

            <Stack spacing={2}>
              <Stack spacing={2} direction="row">
                {Arrayify(form.Init).map((v, i) => (
                  <Stack key={"st-" + i} direction="row" spacing={2}>
                    <ValueInit
                      avail={avail}
                      form={v}
                      dosp={dosp}
                      dospAlways={addPurchase || addSell}
                      doInfAlways={addPurchase}
                      onChange={(e) => onChangeInit(e, i)}
                      onError={(e) => myError("valueI", i, e)}
                    />
                    {i !== 0 && (
                      <CollapseDelete
                        onClick={(e) => onDelete(e, v.Id)}
                      />
                    )}
                  </Stack>
                ))}
                <Divider orientation="vertical" flexItem />
                <InputMoney
                  xlabel="Cost Basis"
                  name="CostBasis"
                  money={form.CostBasis}
                  onChange={onChange_t}
                  onError={(e) => myError("costbasis", null, e)}

                />
                <ValueInflatable
                  xlabel="Expenses"
                  form={form.Expenses}
                  name="Expenses"
                  dosp={false}
                  doInfR={true}
                  showInf={false}
                  onChange={myChangeExpenses}
                  avail={avail}
                  onError={onError}
                />
                <Box>
                  <Stack sx={{ mt: -3 }} direction="row" spacing={2}>
                    <Stack spacing={-2}>
                      {allowIncome && (
                        <CollapseStateLabel
                          add={addIncome}
                          label="Income"
                          onClick={onAddIncome}
                        />
                      )}
                      <CollapseStateLabel
                        add={addNotes}
                        label="Notes"
                        onClick={setAddNotes}
                      />

                    </Stack>
                    <Stack spacing={-2}>
                      <CollapseStateLabel
                        add={addPurchase}
                        label="Purchase"
                        onClick={setAddPurchase}
                      />
                      <CollapseStateLabel
                        add={addSell}
                        label="Sell"
                        onClick={setAddSell}
                      />
                    </Stack>
                  </Stack>
                </Box>

              </Stack>
              {addSell && (
                <Stack spacing={2}>
                  <Divider sx={{ mt: -8 }}>
                    <Chip
                      label="Sell"
                      size="small"
                    />
                  </Divider>
                  <Stack direction="row" spacing={2}>
                    <Typography id="s-die-age-slider" variant="h6" gutterBottom>
                      Sell
                    </Typography>
                    <InputPercentage
                      label="Sell %"
                      percent={form.Sell.Percentage}
                      name="SellPercentage"
                      onChange={onChangeSellP}
                      onError={(e) => myError("sellP", null, e)}
                    />
                    <ValueInflatable
                      xlabel="Sell Costs"
                      form={form.Sell.Costs}
                      name="SellCosts"
                      dosp={false}
                      doInfR={true}
                      showInf={false}
                      onChange={myChangeSellCosts}
                      avail={avail}
                      onError={onError}
                    />
                    {/* <ValueInflatable
                  form={form.Sell.Value}
                  onChange={onChangeSellV}
                  label="Sell"
                  avail={avail}
                  onError={(e) => myError("sellvalue", null, e)}

                /> */}
                  </Stack>
                </Stack>
              )}
              {addIncome && (
                <Stack spacing={2}>
                  <Divider sx={{ mt: -8 }}>
                    <Chip
                      label="Income Producing"
                      size="small"
                    />
                  </Divider>
                  <Stack direction="row" spacing={2}>
                    <Typography id="s-die-age-slider" variant="h6" gutterBottom>
                      Income
                    </Typography>
                    {console.log(form.Income)}
                    <Stack spacing={2}>
                      <Income
                        key={"st-inc"}
                        avail={avail}
                        form={form.Income}
                        onChange={(inc) => onChange_any("Income", inc)}
                        onError={(e) => myError("income", null, e)}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              )}
              {addPurchase && (
                <Stack spacing={2}>
                  <Divider sx={{ mt: -8 }}>
                    <Chip
                      label="Purchase/Renovate/Resize"
                      size="small"
                    />
                  </Divider>
                  <Stack direction="row" spacing={2}>
                    <Typography id="s-die-age-slider" variant="h6" gutterBottom>
                      Purchase
                    </Typography>
                    {console.log(form.Purchase)}
                    <Purchase
                      avail={avail}
                      form={form.Purchase}
                      onChange={(e) => onChangeSub("Purchase", e)}
                      onError={(e) => myError("purchase", null, e)}

                    />
                  </Stack>
                </Stack>
              )}
              {addNotes && (
                <Stack direction="row" spacing={2} sx={{ mx: -4 }}>
                  <Input_label
                    label="Notes"
                    name="Comment"
                    value={form.Comment}
                    maxLength={800}
                    width={800}
                    required={false}
                    onChange={onChange_t}
                    errors={errors}
                    onError={(name, e) => myError(name, null, e)}
                  />

                </Stack>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Container >
  );
};

const AddPropertyAccount = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  account,
  account_uuid,
  accountType,
  add,
  dosp = false,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [added, setAdded] = useState([false, false]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)


  const Update = (cl) => {
    console.log(cl);
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  };

  const getInputData = (client_) => {
    let url = AccountUrl_get(clientJson, "account", account, account_uuid, add, accountType);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAdded([false, false]);
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          console.log(client_);
          Update(client_);
          console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const putRequest = async () => {
    let url = AccountUrl_put(
      clientJson,
      "account",
      form.DataSet[client].Name,
      form.DataSet[client].AccountUuid,
      form.DataSet[client].NameOrig,
      add
    );
    var req = putOptions;
    let post = CleanAvail(form);
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((json) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    console.log("on submit");
    console.log(form);
    putRequest();
  };

  const myClose = (e) => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)

      getInputData(client_p);
    }
  }, [show]);

  useEffect(() => {
    let cl = client === clients[0] ? 0 : 1;
    if (add && dataset && !added[cl]) {
      onAdd();
      let x = added;
      x[cl] = true;
      setAdded(x);
    }
  }, [add, dataset]);

  const onChange_any = (subpath, any) => {
    console.log("any_change: ");
    console.log(any);
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    console.log("Path: " + path);
    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    console.log(nf);
  };

  const onChangeMe = (e, i) => {
    console.log("SA");
    console.log(e);
    console.log(i);

    if (e.Init.length !== 0) {
      let path = "Annual[" + i + "]";
      onChange_any(path, e);
    } else {
      console.log(dataset);
      let path = "Annual[" + i + "]";
      onChange_any(path, e);
      let json = data.current.DataSet[client].Annual.slice();
      json = json.filter((o) => o.Init.length !== 0);
      console.log(json);
      onChange_any("Annual", json);
    }
  };

  const btnClientChanged = (cl) => {
    Update(cl);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };

  const onAdd = () => {
    let n_ann = structuredClone(ann);
    let json = [];
    if (dataset.Annual) {
      json = dataset.Annual.slice();
      n_ann.Id = Math.max(...dataset.Annual.map((o) => o.Id), 0) + 1;
      n_ann.Year = Math.max(...dataset.Annual.map((o) => o.Year), 0) + 1;
    }
    if (n_ann.Year === 1) {
      n_ann.Year = new Date().getFullYear();
    }
    n_ann.BirthYear = dataset.BirthYear;
    json.push(n_ann);
    console.log(json);
    onChange_any("Annual", json);
  };

  const onChange_list = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;
    console.log(values);
    onChange_any(e.target.name, values);
  };

  const onDelete = (e, Id) => {
    let json = dataset.Annual.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Annual", json);
    setDeleted(true)

  };

  const myError = (obj, i, err) => {
    errorSet(errors, setErrors, obj, i, err)
  }


  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType}
        accountType={accountType}
        onClientChange={btnClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}

      >
        {data !== null && dataset !== undefined && dataset !== null && (

          <Stack sx={{ mx: 4 }}>
            {dataset !== undefined && dataset !== null && (
              <Stack direction="row" spacing={2}>
                <InputName
                  key="ds.name"
                  value={dataset.Name}
                  accountName={true}
                  onChange={onChange_t}
                  onError={(e) => myError("name", 0, e)}

                />
                <InputSelectN
                  label="Attributes"
                  name="Attributes"
                  value={dataset.Attributes}
                  onChange={onChange_list}
                  minWidth={200}
                  errors={errors}
                  avail={dataset.Avail.PropertyAttributes}
                />

                <InputSelectN
                  label="Liabilities"
                  name="Liability"
                  value={dataset.Liability}
                  onChange={onChange_list}
                  minWidth={200}
                  errors={errors}
                  avail={dataset.Avail.LiabilityAccounts}
                />
              </Stack>
            )}

            <Stack direction="row" spacing={2}>
              <Stack sx={{ py: 4 }}>
                <CollapseAdd onClick={onAdd}
                  tooltip="Add a new year"
                />
              </Stack>
              <Stack spacing={-3}>
                {Arrayify(dataset.Annual).map((d, i) => (
                  <Stack key={"sd-" + d.Id} direction="row" spacing={2}>
                    <ValueYear
                      key={"annual-i-" + d.Id}
                      avail={dataset.Avail}
                      form={d}
                      dosp={dosp}
                      allowIncome={Arrayify(dataset.Attributes).includes("IncomeProducing")}
                      onChange={(e) => onChangeMe(e, i)}
                      onError={(e) => myError("valueyear", i, e)}
                    />
                    <Stack sx={{ py: 4 }}>
                      <CollapseDelete
                        key={"cd-" + d.Id}
                        onClick={(e) => onDelete(e, d.Id)}
                      />
                    </Stack>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>
        )}

      </AddDialog>
    </>
  );
};

export default AddPropertyAccount;
